/**
 * Platform file actions consumed by translatable components through hooks (SwiftUI @Environment / Compose
 * CompositionLocal): saving an original and copying a link. Web: a download link through the authenticated URL and
 * the Clipboard API (with a "Link copied" toast); iOS: the share sheet / UIPasteboard; Android: DownloadManager /
 * ClipboardManager.
 */
import type { FileRef } from "@bundle/contracts";
import { createContext, useContext } from "react";

export type FilePlatform = {
  /** Saves the original file. */
  download(file: FileRef): void;
  /** Copies a link (an app path like "/acme/f/F1") as an absolute URL, and confirms it. */
  copyLink(path: string): void;
};

const unavailable: FilePlatform = { download: () => {}, copyLink: () => {} };

export const FilePlatformContext = createContext<FilePlatform>(unavailable);

export function useFilePlatform(): FilePlatform {
  return useContext(FilePlatformContext);
}
